export default {
      id: "textFields-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#textFields-usage",
      toString: function () {
        return this.url;
      }
    }